import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ModalContent = styled.div`
    background: #282E33;
    border-radius: 8px;
    width: 400px;
    max-width: 90%;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
    padding: 16px;
    border-bottom: 1px solid #3B444C;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ModalTitle = styled.h3`
    margin: 0;
    color: #B6C2CF;
    font-size: 16px;
`;

export const ModalBody = styled.div`
    padding: 16px;
    color: #B6C2CF;

    p {
        margin: 0 0 16px;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
`;

export const Button = styled.button`
    padding: 8px 16px;
    border-radius: 3px;
    font-size: 14px;
    cursor: pointer;
`;

export const CancelButton = styled(Button)`
    background: transparent;
    border: none;
    color: #B6C2CF;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`;

export const DeleteButton = styled(Button)`
    background: #FF5630;
    border: none;
    color: white;

    &:hover {
        background: #FF4D1F;
    }
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: #B6C2CF;
    font-size: 20px;
    cursor: pointer;
    padding: 4px;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
    }
`;

export const SectionContainer = styled.div`
    margin-bottom: 32px;
`;

export const WorkspaceHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    // max-width: 360px;
`;

export const WorkspaceTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const TitleWithTooltip = styled.div`
  position: relative;
  display: inline-block;

  &:hover span {
    visibility: visible;
    opacity: 1;
  }
`;

export const TooltipText = styled.span`
  visibility: hidden;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  opacity: 0;
  transition: opacity 0.3s;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #B6C2CF;
`;

export const ProjectCount = styled.span`
    color: #8C9BAB;
    font-size: 14px;
    font-weight: normal;
`;

export const WorkspaceActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 8px;
`;

export const ActionButton = styled.button`
    background: #3B444C;
    border: none;
    border-radius: 3px;
    color: #B6C2CF;
    padding: 6px 12px;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover {
        background: #465059;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const ProjectsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 20px;
    align-items: start;

    &.single-row {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        align-items: center;

        &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }
        &::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.05);
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.2);
            border-radius: 4px;
        }

        & > div > div {
            width: 350px;
        }
    }
`;

export const SettingsMenu = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    background: #282E33;
    border-radius: 3px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    min-width: 200px;
    z-index: 10;
`;

export const MenuItem = styled.button`
    width: 100%;
    padding: 8px 12px;
    text-align: left;
    background: none;
    border: none;
    color: #B6C2CF;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
        background: #3B444C;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const MenuContainer = styled.div`
    position: relative;
`;

export const CollapseButton = styled.button`
    background: none;
    border: none;
    color: #B6C2CF;
    font-size: 20px;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
    }
`;
